import { MouseEvent, useRef } from 'react';
import { DropdownMenuProps, DropdownOption } from './dropDownMenu.type';
import './dropDownMenu.css';
import { Trans } from 'react-i18next';
import Loading from '../../assets/loading/loading';
import {
  getIdAttributes,
  useCloseOnOutsideClickAndEsc,
} from '../../utils/helper';

export const idPrefix: string = 'dropdown-menu';

const DropdownMenu = <OptionKey extends string = string>(
  props: DropdownMenuProps<OptionKey>,
) => {
  const prefix: string = idPrefix;

  const menuRef = useRef<HTMLDivElement>(null);

  useCloseOnOutsideClickAndEsc(menuRef, () => {
    props.onClose?.();
  });

  return (
    <div
      ref={menuRef}
      className={`drop-down-container ${props.className}`}
      {...getIdAttributes(prefix, 'container')}
    >
      <ul {...getIdAttributes(prefix, 'list')}>
        {props.options.map(
          (option: DropdownOption<OptionKey>, index: number) => (
            <li
              key={index}
              className="drop-down-option"
              onClick={(event: MouseEvent<HTMLLIElement>) => {
                props.onSelect(option.optionKey || (option.label as OptionKey));
                event.stopPropagation();
              }}
              {...getIdAttributes(
                prefix,
                `option-${option.optionKey ?? index}`,
              )}
            >
              {option.loading ? (
                <div
                  className="flex justify-center items-center h-full"
                  {...getIdAttributes(
                    prefix,
                    `option-loading-${option.optionKey ?? index}`,
                  )}
                >
                  <Loading width={20} height={20} />
                </div>
              ) : (
                <Trans i18nKey={option.label} defaults={option.label} />
              )}
            </li>
          ),
        )}
      </ul>
    </div>
  );
};

export default DropdownMenu;
